import React from "react";

import { useFlags } from "launchdarkly-react-client-sdk";

import { AppConstants } from "../../../../shared/utils/app-constants";
import { CustomImage } from "@vw-marketing/us-components";
import { StyledVehicleImageContainer } from "./styled"

const VehicleImage = ({ vehicleImageURL = '' }: { vehicleImageURL?: string }) => {
  const { ciGuidelinesRollout } = useFlags();

  return (
    <StyledVehicleImageContainer
      ciGuidelinesRollout={ciGuidelinesRollout}
    >
      <CustomImage
        src={vehicleImageURL}
        alt={'vehicle-image'}
        srcPlaceholder={AppConstants.NoVehicle660x338}
      />
    </StyledVehicleImageContainer>
  );
};

export default VehicleImage;